
import { getLabel } from "../../../hooks/use-labels";
import { getStyle } from "../../../hooks/use-styles";
import axios from "../../../utils/axios";

const iconPath = "/assets/icons";

export const menuItems = [
  {
    label: (
      <p style={{ color: getStyle("primaryBlack") }}>
        {getLabel("profileLabel")}
      </p>
    ),
    key: "profile",
    icon: <img src={`${iconPath}/profile.svg`} alt="profile" />,
    id: "profile",
  },
  {
    label: (
      <p style={{ color: getStyle("primaryBlack") }}>
        {getLabel("financeLabel")}
      </p>
    ),
    key: "finance",
    icon: <img src={`${iconPath}/empty-wallet.svg`} alt="finance" />,
    id: "finance",
  },
  {
    label: (
      <p style={{ color: getStyle("primaryBlack") }}>
        {getLabel("savedCardLabel")}
      </p>
    ),
    key: "saved-accounts",
    icon: <img src={`${iconPath}/saved-cards.svg`} alt="finance" />,
    id: "saved-accounts",
  },
  {
    label: (
      <p style={{ color: getStyle("primaryBlack") }}>
        {getLabel("withdrawalLabel")}
      </p>
    ),
    key: "withdrawal",
    icon: <img src={`${iconPath}/withdrawal-requests.svg`} alt="withdrawal" />,
    id: "withdrawal",
  },
  {
    label: (
      <p style={{ color: getStyle("primaryBlack") }}>
        {getLabel("accountSettingsLabel")}
      </p>
    ),
    key: "accountsettings",
    icon: (
      <img src={`${iconPath}/account-settings.svg`} alt="accountsettings" />
    ),
    id: "accountsettings",
  },
  {
    label: (
      <p style={{ color: getStyle("primaryBlack") }}>
        {getLabel("myReviewsLabel")}
      </p>
    ),
    key: "myreviews",
    icon: <img src={`${iconPath}/reviews.svg`} alt="myreviews" />,
    id: "myreviews",
  },
  {
    label: (
      <p style={{ color: getStyle("primaryBlack") }}>
        {getLabel("withdrawalAccountsLabel")}
      </p>
    ),
    key: "withdrawal-accounts",
    icon: <img src={`${iconPath}/withdrawal.svg`} alt="withdrawal-accounts" />,
    id: "withdrawal-accounts",
  },
  {
    label: (
      <p style={{ color: getStyle("primaryBlack") }}>{getLabel("faqLabel")}</p>
    ),
    key: "faqs",
    icon: <img src={`${iconPath}/faqs.svg`} alt="withdrawal" />,
    id: "faqs",
  },
  {
    label: (
      <p style={{ color: getStyle("primaryBlack") }}>{getLabel("privacyLabel")}</p>
    ),
    key: "privacyPolicy",
    icon: <img src={`${iconPath}/privacy.svg`} alt="privacyPolicy" />,
    id: "privacyPolicy",
  },
  {
    label: (
      <p style={{ color: getStyle("primaryBlack") }}>{getLabel("termsLabel")}</p>
    ),
    key: "terms",
    icon: <img src={`${iconPath}/privacy.svg`} alt="terms" />,
    id: "terms",
  },
  {
    label: (
      <p style={{ color: getStyle("primaryColor") }}>{getLabel("logout")}</p>
    ),
    key: "logout",
    icon: <img src={`${iconPath}/logout.svg`} alt="logout" />,
    id: "logout",
  },
];

export const menuActions = ({ key, toggleModal, routeHandler }) => {
  const menuAction = {
    logout: toggleModal,
    profile: () => routeHandler("/account-settings"),
    finance: () => routeHandler("/profile/wallet"),
    withdrawal: () => routeHandler("/profile/withdrawals"),
    accountsettings: () => routeHandler("/account-settings"),
    faqs: () => routeHandler("/faqs"),
    privacyPolicy: () => routeHandler("/privacy"),
    terms: () => routeHandler("/terms"),
    "withdrawal-accounts": () => routeHandler("/withdrawal-accounts"),
    "saved-accounts": () => routeHandler("/saved-accounts"),
    myreviews: () => routeHandler("/my-reviews"),
  };

  menuAction[key] && menuAction[key]();
};


export const performUserLogout = async () => {
  // The new backend logs out the whole identity; the old route took a
  // per-device id, which is why the device lookup that used to be here is
  // gone rather than merely unused.
  return await axios.delete("/identities/logout/");
};
